import React from 'react';
import ReactParticles from '../../Particles/ReactParticles';
import './Banner.css';
import BannerContent from './BannerContent';

const Banner = () => {
        return (
                <div className="">
                        <ReactParticles>
                        </ReactParticles>
                        <BannerContent />
                </div>
        );
};

export default Banner;